import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageBag, ValidationMessagesService } from 'ng2-custom-validation';
import { PushNotificationsService } from 'angular2-notifications'; 

@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html',
  styleUrls: ['./edit-account.component.css']
})
export class EditAccountComponent implements OnInit {
   userUpdateForm : FormGroup;
    errors: MessageBag = new MessageBag();
    errorMessage:any=[];
  loggedinUser:any=[];
  logged_in_user:any=[];
  constructor(private router: Router,private CommonService: WebApiObservableService,private fb: FormBuilder,private validationMessagesService: ValidationMessagesService,private _pushNotifications: PushNotificationsService) {
      _pushNotifications.requestPermission();
   }

  ngOnInit() {
    this.loggedinUser=JSON.parse(localStorage.getItem('LOGGED_IN_USER'));  

     this.userUpdateForm = this.fb.group({
            'name': ['', [
                Validators.required,
                Validators.minLength(2)
                
            ]],            
            'email': ['', [
                Validators.required,
                Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)               
            ]],
            'mobile': ['', [
                Validators.required,
                Validators.minLength(10),
                Validators.maxLength(10)
            ]],
            'password': ['', [              
                Validators.minLength(6)               
            ]],
            'password_new':['',[
                Validators.minLength(6)
            ]],
            'confirm_pass':['',[
                Validators.minLength(6)
            ]]

        });
        this.validationMessagesService
            .seeForErrors(this.userUpdateForm)
            .subscribe((errors: MessageBag) => {
                this.errors = errors;
            });

  }

  
OnSubmit(){     
      let token=localStorage.getItem('AUTH_TOKEN');
    if(this.loggedinUser.password !== undefined && this.loggedinUser.password_new !== undefined){
        if(this.loggedinUser.password_new !== this.loggedinUser.confirm_pass){
            alert('Password does not match. Please re-enter the passwords again');
        }else{ 

            $('.spin').addClass('loading');
            let put_data={
              id:this.loggedinUser.id,
              name:this.loggedinUser.name,
              email:this.loggedinUser.email,
              mobile:this.loggedinUser.mobile,
              password:this.loggedinUser.password_new,
              current_password:this.loggedinUser.password
            }
           
            this.CommonService
            .updateUser('/users/update-user', put_data,token)
            .subscribe(
                result => {
                 
                  this.logged_in_user=result.user;
                  localStorage.setItem('LOGGED_IN_USER',JSON.stringify(result.user));                 
                  $('.spin').removeClass('loading');
                  alert(result.msg);
                  let options = {
                      body: result.msg,
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                     
                  }
                  let notify = this._pushNotifications.create('Success', options).subscribe( 
                   );
                   this.router.navigate(["/"]);
                  },
                error => { $('.spin').removeClass('loading');   this.errorMessage = <any>error}
            );
        }
    }else if(this.loggedinUser.password === undefined || this.loggedinUser.password === ""){
           console.log('else',this.loggedinUser);
         $('.spin').addClass('loading');
            let put_data={
              id:this.loggedinUser.id,
              name:this.loggedinUser.name,
              email:this.loggedinUser.email,
              mobile:this.loggedinUser.mobile,
              password: ""
            }
           
            this.CommonService
            .updateUser('/users/update-user', put_data,token)
            .subscribe(
                result => {                 
                  this.logged_in_user=result.user;
                  localStorage.setItem('LOGGED_IN_USER',JSON.stringify(result.user));                 
                  $('.spin').removeClass('loading');
                  alert(result.msg);
                  let options = {
                      body: result.msg,
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                     
                  }
                  let notify = this._pushNotifications.create('Success', options).subscribe( 
                   );
                   this.router.navigate(["/"]);
                  },
                error => { $('.spin').removeClass('loading');   this.errorMessage = <any>error}
            );
    }

  }
  openAddresses(){
  	this.router.navigate(["addresses"]);
  }

   openOrders(){
  	this.router.navigate(["my-account"]);
  }
}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/edit-account/edit-account.component.ts